import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import ChatBubble from './ChatBubble';
import { useSettings } from '../context/SettingsContext';

export default function Layout() {
  const { settings } = useSettings();
  return (
    <div>
      <Navbar />
      <main>
        <Outlet />
      </main>
      <footer style={{ padding: '40px 0 30px', textAlign: 'center', color: '#6b7280', fontSize: 13 }}>
        © {new Date().getFullYear()} {settings.footer_text}
      </footer>
      <ChatBubble />
    </div>
  );
}
